var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",attrs:{"type":"date","min":_vm.min,"max":_vm.max},domProps:{"value":_vm.updateInput(_vm.value)},on:{"input":function($event){return _vm.updateValue($event.target.value)},"change":function($event){return _vm.changeValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }